import React, { useEffect, useState } from "react";
import "./DashboardWrapper.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDashboardDetails,
  fetchDashboardStats,
} from "../../store/dashboard/dashboardActions";
import GoogleMapComponent from "../../common/GoogleMapComponent";
import pinIcon from "../../assets/Icons/locationPinIcon.svg";
import completedIcon from "../../assets/Icons/green-checkmark.png";
import { Link, useLocation } from "react-router-dom";
import Technology from "../practice/practice-highlights/Technology";
import Amenities from "../practice/practice-highlights/Amenities";
import DashboardCards from "./DashboardCards";
import DashboardBrighterScoreProgressBar from "./DashboardBrighterScoreProgressBar";
import OfficeHours from "../practice/officeHours/OfficeHours";
import PracticePhotos from "../practice/practice-info/PracticePhotos";
// import { fetchPracticePhotos } from "../../store/PracticeInfo/PracticePhotosActions";

const DashboardWrapper = () => {
  const [latLngDetails, setLatLngDetails] = useState([]);
  const [openTechnologyPopup, setOpenTechnologyPopup] = useState(false);
  const [aminitiesPopup, setAminitiesPopup] = useState(false);
  const [officeHoursPopup, setOfficeHoursPopup] = useState(false);
  const [openPhotosPopup, setOpenPhotosPopup] = useState(false);
  const [showError, setShowError] = useState(false);

  const dispatch = useDispatch();

  const { dashboardStatsData, dashboardErrorStats } = useSelector(
    (state) => state.dashboardStats
  );

  const { dashboardDetailsData, dashboardDetailsErrorStats } = useSelector(
    (state) => state.dashboardDetails
  );

  // const { practicePhotosData } = useSelector((state) => state.practicePhotos);
  const location = useLocation();
  const locationHeaderData = location.pathname.split("/");
  const practiceId = locationHeaderData[2];

  useEffect(() => {
    dispatch(fetchDashboardStats(practiceId));
    dispatch(fetchDashboardDetails(practiceId));
    // dispatch(fetchPracticePhotos(practiceId));
  }, []);

  useEffect(() => {
    if (dashboardErrorStats || dashboardDetailsErrorStats) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [dashboardErrorStats, dashboardDetailsErrorStats]);

  useEffect(() => {
    const latLngDetails = [];
    const data = {
      lat: Number(dashboardDetailsData.latitude),
      lng: Number(dashboardDetailsData.longitude),
    };
    latLngDetails.push(data);
    if (dashboardDetailsData.latitude) {
      setLatLngDetails(latLngDetails);
    }
  }, [dashboardDetailsData]);

  const handleFetchData = () => {
    setTimeout(() => {
      dispatch(fetchDashboardStats(practiceId));
    }, 500);
  };

  const RenderPracticeNameDetails = () => {
    if (dashboardStatsData.length < 1) return null;
    return (
      <div className="practiceNameDetailsWrapper">
        <div className="practiceNameWrapper">
          <div className="practiceNameHeading">
            {dashboardDetailsData?.name}
          </div>
          <div className="practiceDetailsAddress">
            <div className="practiceNameDetailsIcon">
              <img alt="" src={pinIcon} width="40px" height="40px" />
            </div>
            <div>
              {[
                dashboardDetailsData?.street1,
                dashboardDetailsData?.street2,
                dashboardDetailsData?.city,
                dashboardDetailsData?.state,
                dashboardDetailsData?.postalCode,
              ]
                ?.filter(Boolean)
                .join(", ")}
            </div>
          </div>
        </div>
        <div className="keyProfileElementsWrapper">
          <div>
            <DashboardBrighterScoreProgressBar
              percentage={dashboardStatsData?.completenessScore}
              title={"PRACTICE INFORMATION"}
            />
          </div>
          <div className="KeyElementsHeadWrapper">
            <div className="keyElementsWrapper">
              <div className="keyElementsHeading">Key Profile Elements</div>
              <Link
                className="editBtnStyle"
                to={`/practice/${practiceId}/profile-information/info`}
              >
                View/Edit All
              </Link>
            </div>
            <div>
              <div>
                <div className="keyElementsItem">
                  {dashboardStatsData?.photosComplete === true && (
                    <div className="statsIcon">
                      <img
                        alt=""
                        src={completedIcon}
                        width="24px"
                        height="16px"
                      />
                    </div>
                  )}
                  {dashboardStatsData?.photosComplete === true ? (
                    <div
                      className="editBtnStyle"
                      onClick={() => {
                        setOpenPhotosPopup(true);
                      }}
                    >
                      Office photos
                    </div>
                  ) : (
                    <div
                      className="keyProfileElementsList"
                      onClick={() => {
                        setOpenPhotosPopup(true);
                      }}
                    >
                      <span className="plus-circle">+</span>
                      <span
                        className="item-text"
                        onClick={() => {
                          setOpenPhotosPopup(true);
                        }}
                      >
                        Add more photos of your office and staff
                      </span>
                    </div>
                  )}
                </div>
                <div className="keyElementsItem">
                  {dashboardStatsData.technologiesComplete === true && (
                    <div className="statsIcon">
                      <img
                        alt=""
                        src={completedIcon}
                        width="24px"
                        height="16px"
                      />
                    </div>
                  )}
                  {dashboardStatsData.technologiesComplete === true ? (
                    <div
                      className="editBtnStyle"
                      onClick={() => {
                        setOpenTechnologyPopup(true);
                      }}
                    >
                      Technologies
                    </div>
                  ) : (
                    <div
                      className="keyProfileElementsList"
                      onClick={() => {
                        setOpenTechnologyPopup(true);
                      }}
                    >
                      <span className="plus-circle">+</span>
                      <span className="item-text">
                        Tell us what technologies your practice offers
                      </span>
                    </div>
                  )}
                </div>
                <div className="keyElementsItem">
                  {dashboardStatsData?.amenitiesAndParkingComplete === true && (
                    <div className="statsIcon">
                      <img
                        alt=""
                        src={completedIcon}
                        width="24px"
                        height="16px"
                      />
                    </div>
                  )}
                  {dashboardStatsData?.amenitiesAndParkingComplete === true ? (
                    <div
                      className="editBtnStyle"
                      onClick={() => {
                        setAminitiesPopup(true);
                      }}
                    >
                      Amenities
                    </div>
                  ) : (
                    <div
                      className="keyProfileElementsList"
                      onClick={() => {
                        setAminitiesPopup(true);
                      }}
                    >
                      <span className="plus-circle">+</span>
                      <span className="item-text">
                        Update your amenities and parking information
                      </span>
                    </div>
                  )}
                </div>
                <div className="keyElementsItem">
                  {dashboardStatsData.officeHoursComplete === true && (
                    <div className="statsIcon">
                      <img
                        alt=""
                        src={completedIcon}
                        width="24px"
                        height="16px"
                      />
                    </div>
                  )}
                  {dashboardStatsData.officeHoursComplete === true ? (
                    <div
                      className="editBtnStyle"
                      onClick={() => {
                        setOfficeHoursPopup(true);
                      }}
                    >
                      Office hours
                    </div>
                  ) : (
                    <div
                      className="keyProfileElementsList"
                      onClick={() => {
                        setOfficeHoursPopup(true);
                      }}
                    >
                      <span className="plus-circle">+</span>
                      <span className="item-text">Add your office hours</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const RenderPracticeMap = () => {
    return (
      <div className="practiceMapWrapper">
        {latLngDetails.length > 0 && (
          <GoogleMapComponent
            latLngList={latLngDetails}
            resizeImg={false}
            zoomLevel={13}
            needIcon={true}
          />
        )}
      </div>
    );
  };

  const RenderTechnologyPopup = () => {
    return (
      <>
        {openTechnologyPopup && (
          <Technology
            openTechPopup={openTechnologyPopup}
            onlyPopup={true}
            closePopupCallback={() => {
              setOpenTechnologyPopup(false);
              handleFetchData();
            }}
          />
        )}
      </>
    );
  };

  const RenderAminities = () => {
    return (
      <>
        {aminitiesPopup && (
          <Amenities
            closePopupCallback={() => {
              setAminitiesPopup(false);
              handleFetchData();
            }}
            onlyPopup={true}
            openAminitiesPopup={aminitiesPopup}
            onSaveTotalCallback={() => {
              // this callback will be removed on API integrations
              handleFetchData();
            }}
          />
        )}
      </>
    );
  };

  const RenderOfficeHours = () => {
    return (
      <>
        {officeHoursPopup && (
          <OfficeHours
            onlyPopup={true}
            openOfficeHoursPopup={officeHoursPopup}
            closePopupCallback={() => {
              setOfficeHoursPopup(false);
              handleFetchData();
            }}
          />
        )}
      </>
    );
  };

  const RenderPhotos = () => {
    // return <>{openPhotosPopup && RenderPhotosPopup()}</>;
    return (
      <>
        {openPhotosPopup && (
          <PracticePhotos
            openPracticePopup={openPhotosPopup}
            onlyPopup={true}
            onlyPhotosTips={true}
            closePhotosPopupCallback={() => {
              setOpenPhotosPopup(false);
              handleFetchData();
            }}
          />
        )}
      </>
    );
  };

  const RenderErrors = () => {
    if (!showError) return null;
    return (
      <div
        className="alert alert-danger"
        role="alert"
        style={{ position: "absolute" }}
      >
        Something went wrong. Please check and try again.
      </div>
    );
  };

  // const handleUpdateStatsData = () => {
  //   dispatch(fetchDashboardStats());
  // }

  return (
    <div className="dashboardWrapper">
      <div className="practiceDetailsandMapWrapper">
        {RenderErrors()}
        {RenderPracticeNameDetails()}
        {RenderPracticeMap()}
        {RenderTechnologyPopup()}
        {RenderAminities()}
        {RenderOfficeHours()}
        {RenderPhotos()}
      </div>
      <div className="providersListWrapper">
        {
          <DashboardCards
            // providersData={handleProvidersData(dashboardStatsData?.providers)}
            // handleUpdateStatsData={handleUpdateStatsData}
            streetAddress={dashboardStatsData?.streetAddress}
          />
        }
      </div>
    </div>
  );
};

export default DashboardWrapper;
